import { Component } from 'react';
import _ from 'lodash';
import { IComponentSizeProp } from '@Primitive/Interfaces';
import { MonacoEditor } from '@Primitive/Monaco';
import { Markdown } from './MarkdownLazy';
import { IsNullOrWhiteSpace } from '@Utils/Micro';
import { Button } from '@Primitive/Button';
import { grey50, red200, blue200 } from '@Utils/Colors';
import Toolbar from '@Primitive/Toolbar';
// ================================================================================================
interface MarkdownEditorProps extends IComponentSizeProp {
    Title: string;
    Text: string;
    readOnly?: boolean;
    onCloseRequest: () => void;
    onSave: (newData: any) => void;
    saveLabel?: string;
}
// ------------------------------------------------------------------------------------------------
interface MarkdownEditorState {
    Text: string;
}
// ------------------------------------------------------------------------------------------------
export class MarkdownEditor extends Component<MarkdownEditorProps, MarkdownEditorState> {
    constructor(props: MarkdownEditorProps) {
        super(props);

        this.state = {
            Text: _.cloneDeep(props.Text)
        };
    }
    // ---------------------------------------------------------------------------------------------------
    componentDidUpdate(prevProps: Readonly<MarkdownEditorProps>) {
        if (prevProps.Text != this.props.Text)
            this.setState({ Text: _.cloneDeep(this.props.Text) });
    }
    // ---------------------------------------------------------------------------------------------------
    render() {
        let toolbarHeight = 35;
        let height = this.props.height - toolbarHeight;
        let editorWidth = this.props.width / 2;

        return <div style={{ overflow: 'hidden', backgroundColor: 'rgb(39, 40, 34)' }}>
            <Toolbar
                title={this.props.Title}
                style={{
                    zIndex: 20,
                    height: toolbarHeight,
                    color: grey50,
                    backgroundColor: 'rgb(91, 97, 99)'
                }}
                rightItems={_.compact([
                    <Button
                        key='discard'
                        label='Discard'
                        height={toolbarHeight}
                        borderRadius={0}
                        shadowLevel={0}
                        style={{ background: 'transparent', color: red200 }}
                        onClick={() => this.setState({ Text: _.cloneDeep(this.props.Text) })}
                    />,
                    _.isFunction(this.props.onCloseRequest) ? <Button
                        key='cancel'
                        label='Cancel'
                        height={toolbarHeight}
                        borderRadius={0}
                        shadowLevel={0}
                        style={{ background: 'transparent', color: red200 }}
                        onClick={() => this.props.onCloseRequest()}
                    /> : null,
                    <Button
                        key='save'
                        label={!IsNullOrWhiteSpace(this.props.saveLabel) ? this.props.saveLabel : 'Save'}
                        height={toolbarHeight}
                        borderRadius={0}
                        shadowLevel={0}
                        style={{ background: 'transparent', color: blue200 }}
                        onClick={() => {
                            if (_.isFunction(this.props.onSave))
                                this.props.onSave(this.state.Text);
                            if (_.isFunction(this.props.onCloseRequest))
                                this.props.onCloseRequest();
                        }}
                    />
                ])}
            />

            <div style={{
                display: 'flex',
                flexDirection: 'row'
            }}>
                <div style={{ width: '50%' }}>
                    <div
                        style={{
                            padding: '8px 0px',
                            backgroundColor: '#ddd',
                            textAlign: 'center',
                            zIndex: 19
                        }}>
                        {'Markdown'}
                    </div>
                    <MonacoEditor
                        value={this.state.Text}
                        onChange={(value) => this.setState({ Text: value })}
                        width={editorWidth}
                        height={height - 36}
                        language='markdown'
                        theme='vs-dark'
                        options={{ selectOnLineNumbers: true, readOnly: this.props.readOnly }}
                    />
                </div>
                <div style={{ width: '50%' }}>
                    <div
                        style={{
                            padding: '8px 0px',
                            backgroundColor: '#ddd',
                            textAlign: 'center',
                            zIndex: 19
                        }}>
                        {'Preview'}
                    </div>
                    <div
                        style={{
                            overflow: 'hidden auto',
                            height: height - 36,
                            backgroundColor: 'white'
                        }}>
                        <Markdown
                            width={this.props.width - editorWidth}
                            source={this.state.Text} />
                    </div>
                </div>
            </div>
        </div>
    }
}